import response from "@/module/patient/card/questionnaire/analysis/response"

export default function({ state, commit, dispatch }, query = {}) {
    if(!query)
        query = {}
    //  Optimization: if all tickets have been loaded, further queries are not necessary
    if (state.loadingTickets && !query.next)
         return

    commit('startLoadingTickets')

    const getPatientTicket = function(provider, queryNext) {
        console.log(queryNext)
        return dispatch('get', {
            url: '/provider/' + provider.provider + '/ticket',
            query: queryNext
        }, {
            root: true
        })
        .then((response) => {
            commit('addTicketsNew', { 
                id: provider.provider,
                tickets: response.ticket
            })
            commit('addTicketsConfig', response.config)
            try {
                const patientMap = response.ticket.reduce((acc, ticket) => {
                    if(!acc[ticket.auth])
                        acc[ticket.auth] = {
                            id: ticket.auth,
                            name: ticket.name
                        }
                    return acc
                }, {})
                commit("addProviderPatients", {
                    id: provider.provider,
                    patient: Object.values(patientMap),
                  })
                if (response.next)
                  dispatch("loadPatientTickets", {
                    next: response.next,
                    provider: provider.provider
                  })
            } catch (error) {
                console.error('Problem setting patients', error)
            }
            
            return response
        })
    }
    if(query.next && query.provider) {
        return getPatientTicket({provider: query.provider}, {next: query.next})
        .then((_) => commit('finishLoadingTickets'))
        .catch((error) => {
            commit('finishLoadingTickets')
            throw error
        })
    }
    else
    return Promise.all(state.providers.map((provider) => {
        return getPatientTicket(provider, {})
    }))
    .then((_) => commit('finishLoadingTickets'))
    .catch((error) => {
        commit('finishLoadingTickets')
        throw error
    })

    return dispatch('get', {
        url: '/provider/' + state.id + '/ticket'
    }, {
        root: true
    })
    .then((response) => {
        commit('addTickets', response.ticket)
        commit('addTicketsConfig', response.config)

        // // If there is a pagination token, store the token
        // if (response.next)
        //     commit('loadNextPatients', {
        //         next: response.next,
        //         ...query
        //     })
        // // Otherwise store that all patients have been loaded if this was a query for all patients
        // else if (query == null || (query.label === null && query.search === null))
        //     commit('loadedAllPatients')

         commit('finishLoadingTickets')
    })
    .catch((error) => {
        commit('finishLoadingTickets')
        throw error
    })
}
